import React from 'react';
import GameWindowHeader from "../GameWindowHeader";
import GameTabViewUI from "../Tabs/GameTabViewUI";
import GameData from "../../../gameplay/model/GameData";
import InvestStationCard from "./InvestStationCard";
import CurrencyCard from "../GeneralCards/CurrencyCard";
import cashIcon from "../../../images/gameplay_ui/icons/cash_icon.svg";
import InvestRuntimeStationData from "./InvestRuntimeStationData";
import {GetBrigadeCost, GetLocoCost, GetSecurityLevelCost, GetSparePartCost} from "../../../gameplay/model/Balance";
import {ELECTRO_TYPE, LOCO_TYPE} from "../../../constants/Constants";
import GameButtonWithText from "../GameButtonWithText";
import InvestRepairCard from "./InvestRepairCard";
import InvestRuntimeRepairData from "./InvestRuntimeRepairData";
import InvestDispetcherCard from "./InvestDispetcherCard";
import InvestSecurityCard from "./InvestSecurityCard";
import DispetcherCenter from "../../../gameplay/model/DispetcherCenter";
import ConfirmPopup from "../Popups/ConfirmPopup";
import UtilsFunctions from "../../../utils/UtilsFunctions";

export default class InvestWindow extends React.Component {

    constructor() {
        super();

        this.state = {
            currentPage: 0,
            runtimeData: {
                stationData: null,
                repairData: null,
                dispetcher: null,
                securityLevel: 0
            },
            isShowConfirm: false
        }

        let infraIndex = UtilsFunctions.getRoleNameIndex("Зам. по инфраструктуре и ремонту");
        this.isInfraMaster = UtilsFunctions.playerHasRole(infraIndex);
    }

    componentDidMount() {
        let stationData = [
            new InvestRuntimeStationData(0),
            new InvestRuntimeStationData(1),
            new InvestRuntimeStationData(2),
            new InvestRuntimeStationData(3)
        ];
        let repairData = [
            new InvestRuntimeRepairData(0),
            new InvestRuntimeRepairData(1),
            new InvestRuntimeRepairData(2)
        ];
        this.setState({
            runtimeData: {
                stationData: stationData,
                repairData: repairData,
                dispetcher: new DispetcherCenter(0),
                securityLevel: GameData.CurrentGame.securityLevel
            }
        });
    }

    selectPage(pageNum) {
        this.setState({
            currentPage: pageNum
        })
    }

    getStationsUI() {
        let cards = []
        let containerStyle = {
            display: "grid",
            gridTemplateColumns: "270px 270px 270px 270px",
            gridTemplateRows: "385px",
            paddingLeft: "10px",
            paddingTop: "20px",
            gridRowGap: "10px",
            gridColumnGap: "10px"
        }
        let stations = GameData.CurrentGame.getStations();

        for (let i = 0; i < stations.length; i++) {
            let station = stations[i];
            cards.push(<InvestStationCard key={`card-${i}`} disabled={!this.isInfraMaster} station={station} parent={this}/>)
        }
        return <div style={containerStyle}>{cards}</div>;
    }

    getRepairAndSecureUI() {
        let repairsShops = GameData.CurrentGame.getRepairShops();
        let mainStyle = {
            display: "flex",
            paddingLeft: "10px",
            paddingRight: "10px",
            paddingTop: "20px",
            justifyContent: "space-between"
        }

        let result = [];
        let repair = [];
        for (let i = 0; i < repairsShops.length; i++) {
            let repairShop = repairsShops[i];
            repair.push(<InvestRepairCard key={`repair-${i}`} disabled={!this.isInfraMaster} repairShop={repairShop} parent={this}/>);
        }
        let moreBridages = this.state.runtimeData.dispetcher.brigades - GameData.CurrentGame.getDispetcher().brigades > 0;
        result.push(repair);
        result.push(<InvestDispetcherCard key={'dispetcher'} dispetcher={GameData.CurrentGame.dispetcher} parent={this}
                                          disabled={!this.isInfraMaster}
                                          canSell={moreBridages} canBuy={!moreBridages}/>);
        result.push(<InvestSecurityCard key={'security'} securityLevel={this.state.runtimeData.securityLevel} parent={this}/>);
        result = <div style={mainStyle}>{result}</div>
        return result;
    }

    calcExpanses() {
        if (!this.state.runtimeData.stationData) return 0;
        let expanseSum = 0;
        for (let i = 0; i < this.state.runtimeData.stationData.length; i++) {
            let stationData = this.state.runtimeData.stationData[i];
            expanseSum += Math.abs(stationData.brigades) * GetBrigadeCost(true);
            expanseSum += Math.abs(stationData.locoBrigades) * GetBrigadeCost(true);
            expanseSum += Math.abs(stationData.loco) * GetLocoCost(LOCO_TYPE);
            expanseSum += Math.abs(stationData.electro) * GetLocoCost(ELECTRO_TYPE);
        }
        for (let i = 0; i < this.state.runtimeData.repairData.length; i++) {
            let repairData = this.state.runtimeData.repairData[i];
            expanseSum += Math.abs(repairData.brigades) * GetBrigadeCost(true);
            expanseSum += Math.abs(repairData.spareParts) * GetSparePartCost(true);
        }
        expanseSum += Math.abs(this.state.runtimeData.dispetcher.brigades) * GetBrigadeCost(true);
        expanseSum += (this.state.runtimeData.securityLevel - GameData.CurrentGame.getSecurityLevel()) * GetSecurityLevelCost();
        return expanseSum;
    }

    getAvailableCash() {
        return GameData.CurrentGame.cash - this.calcExpanses();
    }

    onSubmit() {
        let data = this.state.runtimeData;
        data.dispetcherBrigades = data.dispetcher.brigades;

        GameData.CurrentGame.commitInvestChanges(this.props.teamID, data, this.calcExpanses());
        this.hide();
    }

    hide() {
        this.props.onHide();
    }

    toggleConfirm() {
        this.setState({
            isShowConfirm: !this.state.isShowConfirm
        })
    }

    render() {
        const bgWidth = 1134;
        const bgHeight = 565;

        let currency = <CurrencyCard icon={cashIcon} value={this.getAvailableCash()}/>
        let styleBg = {
            position: "relative",
            width: `${bgWidth}px`,
            height: `${bgHeight}px`,
            background: "white",
            borderRadius: "3px",
            top: "50%",
            left: "50%",
            transform: "translate(-50%,-50%)"
        }
        if (!this.props.isShow)
            return "";
        let cards = "";
        if (this.state.currentPage === 0) {
            cards = this.getStationsUI();
        } else {
            cards = this.getRepairAndSecureUI();
        }

        let confirmPopup = <ConfirmPopup
            message={"Если вы нажмете подтвердить, то больше не сможете делать инвестиции в это году. Продолжить?"}
            title={"Завершение инвестиций"}
            onOk={this.onSubmit.bind(this)}
            onCancel={this.toggleConfirm.bind(this)}
        />
        return <div className="in-game-popup" style={{
            width: this.props.width,
            height: this.props.height,
            background: "rgba(0, 0, 0, 0.5)",
            backdropFilter: "blur(5px)"
        }}>
            <div style={styleBg}>
                <GameWindowHeader width={bgWidth}
                                  height={40}
                                  title={"Начало года: инвестиции"}
                                  currencyBlocks={currency}
                                  isClosable={!this.isInfraMaster}
                                  onHide={this.props.onHide}
                />
                <div style={{
                    paddingLeft: "10px",
                    paddingTop: "20px"
                }}>
                    <GameTabViewUI width={600} height={30} tabs={["Станции", "Ремонт и безопасность"]}
                                   onSelectedIndex={this.selectPage.bind(this)}/>
                </div>
                {cards}
                <div style={{height: "15px"}}/>
                {this.state.currentPage === 1 && <GameButtonWithText title={"Подтвердить"} width={250} height={40} style={{}}
                                    disabled={!this.isInfraMaster}
                                    onClick={this.toggleConfirm.bind(this)}/>}
            </div>
            {this.state.isShowConfirm && confirmPopup}
        </div>
    }
}
